// kapigen version 0.1.34
// eslint-disable
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { google } from "../google";
import { createClient } from "../../requestClientInternal";
export var CreateCompetitionTagsRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultCreateCompetitionTagsResponse = {};
export var CreateCompetitionTagsResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultCreateCompetitionTagsResponse, wireFormat);
        return message;
    }
};
export var CreateLearnTrackTagsRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultCreateLearnTrackTagsResponse = {};
export var CreateLearnTrackTagsResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultCreateLearnTrackTagsResponse, wireFormat);
        return message;
    }
};
export var CreateTagRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
export var DeleteCompetitionTagsRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultDeleteCompetitionTagsResponse = {};
export var DeleteCompetitionTagsResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultDeleteCompetitionTagsResponse, wireFormat);
        return message;
    }
};
export var DeleteLearnTrackTagsRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultDeleteLearnTrackTagsResponse = {};
export var DeleteLearnTrackTagsResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultDeleteLearnTrackTagsResponse, wireFormat);
        return message;
    }
};
export var DeleteTagRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultDeleteTagResponse = {
    warningMessage: "",
    competitionCategoriesMessage: "",
    datasetCategoriesMessage: "",
    forumTopicCategoriesMessage: "",
    kernelCategoriesMessage: "",
    learnTrackCategoriesMessage: "",
    userAutoCategoryRemovalsMessage: ""
};
export var DeleteTagResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultDeleteTagResponse, wireFormat);
        return message;
    }
};
export var GetTaggedEntityCountRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultGetTaggedEntityCountResponse = {
    warningMessage: "",
    competitionCategoriesCount: 0,
    datasetCategoriesCount: 0,
    forumTopicCategoriesCount: 0,
    kernelCategoriesCount: 0,
    learnTrackCategoriesCount: 0
};
export var GetTaggedEntityCountResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultGetTaggedEntityCountResponse, wireFormat);
        return message;
    }
};
export var GetTagHierarchyRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultGetTagHierarchyResponse = {
    roots: []
};
export var GetTagHierarchyResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultGetTagHierarchyResponse, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.roots) {
            message.roots = wireFormat.roots.map(function(i) {
                return TagNodeWireFormat3.fromJson(i);
            });
        }
        return message;
    }
};
export var GetTagsByIdRequestWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.orderBy) {
            wireFormat.orderBy = GetTagsByIdOrderByWireFormat3.toJson(message.orderBy);
        }
        return wireFormat;
    }
};
export var ListTagsRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultListTagsResponse = {
    featuredTags: [],
    hotTags: [],
    tagsCount: 0,
    pageSize: 0
};
export var ListTagsResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultListTagsResponse, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.featuredTags) {
            message.featuredTags = wireFormat.featuredTags.map(function(i) {
                return TagWireFormat3.fromJson(i);
            });
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.hotTags) {
            message.hotTags = wireFormat.hotTags.map(function(i) {
                return TagWireFormat3.fromJson(i);
            });
        }
        return message;
    }
};
export var MergeTagRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultMergeTagResponse = {
    warningMessage: "",
    competitionCategoriesMessage: "",
    datasetCategoriesMessage: "",
    forumTopicCategoriesMessage: "",
    kernelCategoriesMessage: "",
    learnTrackCategoriesMessage: "",
    userAutoCategoryRemovalsMessage: ""
};
export var MergeTagResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultMergeTagResponse, wireFormat);
        return message;
    }
};
export var SearchTagsLegacyRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultSearchTagsLegacyResponse = {
    tags: []
};
export var SearchTagsLegacyResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultSearchTagsLegacyResponse, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.tags) {
            message.tags = wireFormat.tags.map(function(i) {
                return TagWireFormat3.fromJson(i);
            });
        }
        return message;
    }
};
export var SearchTagsRequestWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.searchType) {
            wireFormat.searchType = TagTypeWireFormat3.toJson(message.searchType);
        }
        return wireFormat;
    }
};
var defaultTag = {
    id: 0,
    name: "",
    fullPath: "",
    listingUrl: "",
    datasetCount: 0,
    competitionCount: 0,
    notebookCount: 0,
    modelCount: 0,
    tagUrl: "",
    displayName: "",
    googleMaterialIcon: ""
};
export var TagWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultTag, wireFormat);
        return message;
    },
    toJson: function toJson(message) {
        return message;
    }
};
var defaultTagList = {
    tags: []
};
export var TagListWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultTagList, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.tags) {
            message.tags = wireFormat.tags.map(function(i) {
                return TagWireFormat3.fromJson(i);
            });
        }
        if (wireFormat) {
            message.type = TagTypeWireFormat3.fromJson(wireFormat.type);
        }
        return message;
    },
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.tags) {
            wireFormat.tags = message.tags.map(function(i) {
                return TagWireFormat3.toJson(i);
            });
        }
        if (message === null || message === void 0 ? void 0 : message.type) {
            wireFormat.type = TagTypeWireFormat3.toJson(message.type);
        }
        return wireFormat;
    }
};
var defaultTagNode = {
    children: []
};
export var TagNodeWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultTagNode, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.tag) {
            message.tag = TagWireFormat3.fromJson(wireFormat.tag);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.children) {
            message.children = wireFormat.children.map(function(i) {
                return TagNodeWireFormat3.fromJson(i);
            });
        }
        return message;
    }
};
export var UpdateForumTopicTagsRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultUpdateForumTopicTagsResponse = {};
export var UpdateForumTopicTagsResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultUpdateForumTopicTagsResponse, wireFormat);
        return message;
    }
};
export var GetTagsByIdOrderBy;
(function(GetTagsByIdOrderBy) {
    GetTagsByIdOrderBy["UNSPECIFIED"] = "unspecified";
    GetTagsByIdOrderBy["REQUEST_ORDER"] = "requestOrder";
})(GetTagsByIdOrderBy || (GetTagsByIdOrderBy = {}));
export var GetTagsByIdOrderByWireFormat3 = {
    toJson: function toJson(enumVal) {
        switch(enumVal){
            case GetTagsByIdOrderBy.UNSPECIFIED:
            case 0:
            default:
                return "GET_TAGS_BY_ID_ORDER_BY_UNSPECIFIED";
            case GetTagsByIdOrderBy.REQUEST_ORDER:
            case 1:
                return "GET_TAGS_BY_ID_ORDER_BY_REQUEST_ORDER";
        }
    }
};
export var TagType;
(function(TagType) {
    TagType["UNSPECIFIED"] = "unspecified";
    TagType["SEARCH_RESULT"] = "searchResult";
    TagType["DATASET"] = "dataset";
    TagType["COMPETITION"] = "competition";
    TagType["NOTEBOOK"] = "notebook";
    TagType["TASK"] = "task";
    TagType["MODEL"] = "model";
})(TagType || (TagType = {}));
export var TagTypeWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        switch(wireFormat){
            case "TAG_TYPE_UNSPECIFIED":
            default:
                return TagType.UNSPECIFIED;
            case "TAG_TYPE_SEARCH_RESULT":
                return TagType.SEARCH_RESULT;
            case "TAG_TYPE_DATASET":
                return TagType.DATASET;
            case "TAG_TYPE_COMPETITION":
                return TagType.COMPETITION;
            case "TAG_TYPE_NOTEBOOK":
                return TagType.NOTEBOOK;
            case "TAG_TYPE_TASK":
                return TagType.TASK;
            case "TAG_TYPE_MODEL":
                return TagType.MODEL;
        }
    },
    toJson: function toJson(enumVal) {
        switch(enumVal){
            case TagType.UNSPECIFIED:
            case 0:
            default:
                return "TAG_TYPE_UNSPECIFIED";
            case TagType.SEARCH_RESULT:
            case 1:
                return "TAG_TYPE_SEARCH_RESULT";
            case TagType.DATASET:
            case 2:
                return "TAG_TYPE_DATASET";
            case TagType.COMPETITION:
            case 3:
                return "TAG_TYPE_COMPETITION";
            case TagType.NOTEBOOK:
            case 4:
                return "TAG_TYPE_NOTEBOOK";
            case TagType.TASK:
            case 5:
                return "TAG_TYPE_TASK";
            case TagType.MODEL:
            case 6:
                return "TAG_TYPE_MODEL";
        }
    }
};
export var tagsClient = {
    tagService: {
        // Tag a given competition with one or many tags
        createCompetitionTags: createClient(CreateCompetitionTagsRequestWireFormat3, CreateCompetitionTagsResponseWireFormat3, "tags.TagService/CreateCompetitionTags"),
        // Tag a given learn track with one or many tags
        createLearnTrackTags: createClient(CreateLearnTrackTagsRequestWireFormat3, CreateLearnTrackTagsResponseWireFormat3, "tags.TagService/CreateLearnTrackTags"),
        createTag: createClient(CreateTagRequestWireFormat3, google.protobuf.EmptyWireFormat3, "tags.TagService/CreateTag"),
        // Untag a given competition, removing one or many tags
        deleteCompetitionTags: createClient(DeleteCompetitionTagsRequestWireFormat3, DeleteCompetitionTagsResponseWireFormat3, "tags.TagService/DeleteCompetitionTags"),
        // Untag a given learn track, removing one or many tags
        deleteLearnTrackTags: createClient(DeleteLearnTrackTagsRequestWireFormat3, DeleteLearnTrackTagsResponseWireFormat3, "tags.TagService/DeleteLearnTrackTags"),
        deleteTag: createClient(DeleteTagRequestWireFormat3, DeleteTagResponseWireFormat3, "tags.TagService/DeleteTag"),
        getTaggedEntityCount: createClient(GetTaggedEntityCountRequestWireFormat3, GetTaggedEntityCountResponseWireFormat3, "tags.TagService/GetTaggedEntityCount"),
        // Fetch the hierarchical structure of all tags
        getTagHierarchy: createClient(GetTagHierarchyRequestWireFormat3, GetTagHierarchyResponseWireFormat3, "tags.TagService/GetTagHierarchy"),
        getTagsById: createClient(GetTagsByIdRequestWireFormat3, TagListWireFormat3, "tags.TagService/GetTagsById"),
        listTags: createClient(ListTagsRequestWireFormat3, ListTagsResponseWireFormat3, "tags.TagService/ListTags"),
        mergeTag: createClient(MergeTagRequestWireFormat3, MergeTagResponseWireFormat3, "tags.TagService/MergeTag"),
        searchTags: createClient(SearchTagsRequestWireFormat3, TagListWireFormat3, "tags.TagService/SearchTags"),
        searchTagsLegacy: createClient(SearchTagsLegacyRequestWireFormat3, SearchTagsLegacyResponseWireFormat3, "tags.TagService/SearchTagsLegacy"),
        // Tag a given forum topic with one or many tags, removing any tags not
        // specified in the request
        updateForumTopicTags: createClient(UpdateForumTopicTagsRequestWireFormat3, UpdateForumTopicTagsResponseWireFormat3, "tags.TagService/UpdateForumTopicTags")
    }
};
